/* Pro Direct Tools — tabs + ecosystem filters for pdt-* sections.
   No dependencies; event-delegated so it keeps working after theme-editor section reloads. */
(function () {
  function applyEco(section) {
    var eco = section.getAttribute('data-eco-active') || 'all';
    section.querySelectorAll('[data-pdt-panel]').forEach(function (panel) {
      var shown = 0;
      panel.querySelectorAll('[data-eco-item]').forEach(function (card) {
        /* data-ecos lists every battery system the card fits (multi-system tools match each one) */
        var ecos = (card.getAttribute('data-ecos') || card.getAttribute('data-eco') || '').split(' ');
        var match = eco === 'all' || ecos.indexOf(eco) !== -1;
        card.hidden = !match;
        if (match) shown++;
      });
      var empty = panel.querySelector('[data-pdt-empty]');
      if (empty) empty.hidden = shown > 0;
    });
    var more = section.querySelector('[data-pdt-eco-more]');
    if (more) {
      var btn = section.querySelector('[data-eco-pick="' + eco + '"]');
      var url = btn && btn.getAttribute('data-eco-url');
      if (eco !== 'all' && url) {
        more.hidden = false;
        more.href = url;
        more.textContent = 'Shop all ' + btn.getAttribute('data-eco-label') + ' Compatible tools';
      } else {
        more.hidden = true;
      }
    }
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-pdt-tab]');
    if (tab) {
      var root = tab.closest('[data-pdt-tabs]');
      var id = tab.getAttribute('data-pdt-tab');
      root.querySelectorAll('[data-pdt-tab]').forEach(function (b) {
        b.setAttribute('aria-selected', b === tab ? 'true' : 'false');
      });
      root.querySelectorAll('[data-pdt-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-pdt-panel') !== id;
      });
      return;
    }
    var pick = e.target.closest('[data-eco-pick]');
    if (pick) {
      var section = pick.closest('[data-pdt-ecofilter]');
      var val = pick.getAttribute('data-eco-pick');
      if (section.getAttribute('data-eco-active') === val) val = 'all'; /* tap again to clear */
      section.setAttribute('data-eco-active', val);
      section.querySelectorAll('[data-eco-pick]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-eco-pick') === val ? 'true' : 'false');
      });
      applyEco(section);
    }
  });

  /* Mobile menu drawer accordions: runs in the capture phase so Status's slide-in submenu
     handler doesn't fire; opening one item closes its open siblings. */
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('#menu-drawer.pdt-accordion summary');
    if (!summary) return;
    var details = summary.parentElement;
    e.preventDefault();
    e.stopPropagation();
    var opening = !details.hasAttribute('open');
    var list = details.closest('ul');
    if (opening && list) {
      list.querySelectorAll(':scope > li > details[open]').forEach(function (d) {
        if (d !== details) {
          d.removeAttribute('open');
          var s = d.querySelector(':scope > summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        }
      });
    }
    if (opening) details.setAttribute('open', ''); else details.removeAttribute('open');
    summary.setAttribute('aria-expanded', opening ? 'true' : 'false');
  }, true);
})();

/* "Add to order" (snippets/pdt-add-item): add via the Ajax cart, then refresh Status's cart drawer in place.
   Falls back to the cart page if the drawer isn't available. */
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-pdt-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var drawer = document.querySelector('cart-drawer');
    var body = new FormData(form);
    if (drawer && drawer.renderContents) {
      body.append('sections', 'cart-drawer,cart-icon-bubble');
      body.append('sections_url', window.location.pathname);
    }
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { throw new Error(res.description || 'Could not add'); }
      if (drawer && drawer.renderContents && res.sections) { drawer.renderContents(res); }
      else { window.location.href = '/cart'; }
    }).catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });
})();

/* v3 PDP prototype: set the currency code ("GBP") smaller than the price, including after variant changes */
(function () {
  if (!document.documentElement.classList.contains('pdt-pdp-v3')) return;
  function wrap(root) {
    root.querySelectorAll('.product__info-container .price .price-item, .product__info-container .price .money').forEach(function (el) {
      if (el.querySelector('.pdt-cur')) return;
      var m = el.textContent.match(/^(.*?)\s+([A-Z]{3})\s*$/);
      if (m && el.children.length === 0) { el.innerHTML = ''; el.append(m[1]); var s = document.createElement('span'); s.className = 'pdt-cur'; s.textContent = m[2]; el.append(s); }
    });
  }
  function run() { wrap(document); var info = document.querySelector('.product__info-container'); if (info) new MutationObserver(function () { wrap(document); }).observe(info, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* V3 navigation: desktop mega menus (hover intent, click/touch, keyboard, Esc) + mobile drill-down (scroll lock, back, Esc). */
(function () {
  var items = [].slice.call(document.querySelectorAll('[data-pdt-nav-item]'));
  if (items.length) {
    var openT, closeT, current = null;
    function setOpen(item, on) {
      var a = item.querySelector('.pdt-nav__top');
      item.classList.toggle('is-open', on);
      if (a) a.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { current = item; } else if (current === item) { current = null; }
    }
    function closeAll(except) { items.forEach(function (i) { if (i !== except) setOpen(i, false); }); }
    items.forEach(function (item) {
      var a = item.querySelector('.pdt-nav__top');
      item.addEventListener('mouseenter', function () { clearTimeout(closeT); clearTimeout(openT); openT = setTimeout(function () { closeAll(item); setOpen(item, true); }, current ? 0 : 70); });
      item.addEventListener('mouseleave', function () { clearTimeout(openT); closeT = setTimeout(function () { setOpen(item, false); }, 180); });
      a.addEventListener('click', function (e) {
        // touch / pen: first tap opens, second tap follows the link
        if (!item.classList.contains('is-open') && (e.pointerType === 'touch' || e.pointerType === 'pen' || window.matchMedia('(hover: none)').matches)) { e.preventDefault(); closeAll(item); setOpen(item, true); }
      });
      a.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') {
          e.preventDefault(); closeAll(item); setOpen(item, true);
          var f = item.querySelector('.pdt-mega a'); if (f) f.focus();
        }
      });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) setOpen(item, false); });
      item.addEventListener('keydown', function (e) { if (e.key === 'Escape' && item.classList.contains('is-open')) { setOpen(item, false); a.focus(); } });
    });
    document.addEventListener('click', function (e) { if (current && !current.contains(e.target)) setOpen(current, false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && current) { var c = current; setOpen(c, false); if (c.contains(document.activeElement)) c.querySelector('.pdt-nav__top').focus(); } });
  }

  var nav = document.querySelector('[data-pdt-mnav]');
  var opener = document.querySelector('[data-pdt-mnav-open]');
  if (!nav || !opener) return;
  // the sticky header creates a containing block for fixed elements — render the drawer at <body> level
  if (nav.parentElement !== document.body) document.body.appendChild(nav);
  var root = nav.querySelector('[data-pdt-level="root"]');
  function show(level) {
    nav.querySelectorAll('.pdt-mnav__level').forEach(function (l) { var on = l === level; l.classList.toggle('is-active', on); l.setAttribute('aria-hidden', on ? 'false' : 'true'); });
    // don't pop the phone keyboard: focus the back control on sub-levels, the close button on the first level
    var f = level.querySelector('[data-pdt-level-back]') || nav.querySelector('.pdt-mnav__close'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 210);
  }
  function openNav() {
    nav.hidden = false; document.documentElement.classList.add('pdt-mnav-lock'); opener.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { nav.classList.add('is-open'); show(root); });
  }
  function closeNav() {
    nav.classList.remove('is-open'); opener.setAttribute('aria-expanded', 'false'); document.documentElement.classList.remove('pdt-mnav-lock');
    setTimeout(function () { nav.hidden = true; }, 200); opener.focus();
  }
  opener.addEventListener('click', openNav);
  nav.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pdt-mnav-close], [data-pdt-level-open], [data-pdt-level-back]');
    if (!t) return;
    if (t.hasAttribute('data-pdt-mnav-close')) closeNav();
    else if (t.hasAttribute('data-pdt-level-open')) show(nav.querySelector('[data-pdt-level="' + t.getAttribute('data-pdt-level-open') + '"]'));
    else show(root);
  });
  nav.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeNav(); return; }
    if (e.key === 'Tab') { // keep focus inside the open menu
      var f = [].slice.call(nav.querySelectorAll('.pdt-mnav__head button, .pdt-mnav__level.is-active a, .pdt-mnav__level.is-active button, .pdt-mnav__level.is-active input'));
      if (!f.length) return; var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();

/* Live chat (22 Oct): open Shopify Inbox from our own buttons. The tap must finish first, otherwise Inbox treats the same
   click as an outside click and closes straight away. Then check it opened and retry once. Returns false if Inbox isn't
   on the page, so callers can fall back to the contact link. */
window.pdtOpenChat = function () {
  // Before first use, <shopify-chat> only holds a light placeholder launcher; the real chat (shopify-agent-runtime) loads on
  // the first click and opens itself. Once loaded, its own launcher lives in the runtime's shadow root.
  var sc = document.querySelector('shopify-chat');
  if (!sc || !sc.shadowRoot) return false;
  function runtime() { return sc.shadowRoot.querySelector('shopify-agent-runtime'); }
  function launcher() {
    var r = runtime();
    var real = r && r.shadowRoot && r.shadowRoot.querySelector('button.activator');
    return real || sc.shadowRoot.querySelector('button.activator');
  }
  function isOpen() { var r = runtime(); return !!(r && r.hasAttribute('open')); }
  if (!launcher()) return false;
  if (isOpen()) return true;
  setTimeout(function () {
    var b = launcher(); if (b) b.click();
    // retry once only if the real chat has loaded but stayed closed
    setTimeout(function () { if (runtime() && !isOpen()) { var b2 = launcher(); if (b2) b2.click(); } }, 1500);
  }, 60);
  return true;
};

/* AfterShip Returns centre (/apps/aftership-returns-center, 22 Oct). The app renders inside <main>'s shadow root, which
   theme CSS can't reach, so we add our own <style> there — same look as the tracking page and contact cards.
   Hooks are the app's data-testid / Astra-* names (stable); the card is tagged by JS because its classes are hashed. */
(function () {
  if (location.pathname.indexOf('/apps/aftership-returns') !== 0) return;
  var CSS = [
    ':host{background:#fff!important}',
    '.returns-app img[src*="returns-page-background"]{display:none!important}',
    '.returns-app :is(div,span,p,a,label,input,button,li){font-family:var(--pdt-font-head,Inter,system-ui,sans-serif)!important}',
    '[data-pdt-card]{background:#F7F8F9!important;border:1px solid #E6E8EB!important;border-radius:20px!important;box-shadow:none!important;max-width:520px;margin-inline:auto!important;width:100%;box-sizing:border-box}',
    '[data-testid=order-lookup-title],[data-testid=order-lookup-title] *{font-weight:700!important;letter-spacing:-.025em!important;font-size:clamp(28px,3.4vw,38px)!important;line-height:1.15!important;color:#16171A!important}',
    '.Astra-TextField-inputWrapper{border-radius:12px!important;background:#fff!important;border:1px solid #DCDDE1!important;box-shadow:none!important;min-height:52px;transition:border-color .2s,box-shadow .2s}',
    '.Astra-TextField-inputWrapper:focus-within{border-color:#16171A!important;box-shadow:0 0 0 3px rgba(22,23,26,.08)!important}',
    '.Astra-TextField-input,.Astra-TextField-inputWrapper input{font-size:16px!important;color:#16171A!important;background:transparent!important}',
    '.Astra-TextField-root label{color:#5F6066!important}',
    '[data-testid^=order-lookup-verify-method]{color:#16171A!important;font-weight:600!important;text-decoration:underline;text-underline-offset:3px}',
    '[data-testid=order-lookup-submit-button]{border-radius:12px!important;background:#16171A!important;border:1px solid #16171A!important;min-height:52px;transition:background-color .2s,opacity .2s}',
    '[data-testid=order-lookup-submit-button] *{color:#fff!important;font-family:var(--pdt-font-ui,"Barlow Condensed",sans-serif)!important;font-weight:800!important;font-size:18px!important;letter-spacing:.06em!important;text-transform:uppercase!important}',
    '[data-testid=order-lookup-submit-button]:hover:not([disabled]){background:#2A2B30!important}',
    '[data-testid=order-lookup-submit-button][disabled]{opacity:.55!important;cursor:not-allowed}',
    ':has(> [data-pdt-card]){margin-top:clamp(22px,4vw,40px)!important;margin-bottom:40px!important}',
    '[data-pdt-card] p{color:#5F6066!important;font-size:13px!important;line-height:1.5!important}',
    '[data-pdt-card] a{color:#16171A!important;font-weight:600!important;text-underline-offset:3px}',
    '@media (max-width:599px){[data-pdt-card]{border-radius:18px!important}}'
  ].join('\n');
  function apply() {
    var main = document.querySelector('main');
    var sr = main && main.shadowRoot;
    if (!sr) return false;
    if (!sr.getElementById('pdt-returns-style')) {
      var st = document.createElement('style');
      st.id = 'pdt-returns-style';
      st.textContent = CSS;
      sr.appendChild(st);
    }
    var t = sr.querySelector('[data-testid=order-lookup-title]');
    if (t && !sr.querySelector('[data-pdt-card]')) {
      for (var p = t.parentElement; p; p = p.parentElement) {
        if (getComputedStyle(p).backgroundColor === 'rgb(255, 255, 255)') { p.setAttribute('data-pdt-card', ''); break; }
      }
    }
    return true;
  }
  var n = 0;
  var iv = setInterval(function () { if (apply() && ++n > 40) clearInterval(iv); }, 250); /* keep re-tagging ~10s while the app renders */
  document.addEventListener('click', function () { setTimeout(apply, 300); }, true);
})();
